import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"


import { isEmptyString } from '@/utils'
import { defineComponent, ref, defineProps, onMounted } from 'vue'

const __default__ = defineComponent({
  name: 'DatePicker'
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  dataValue: {
    type: String,
    require: true
  },
  pickerType: {
    type: String,
    require: true
  },
  valueFormat: {
    type: String,
    require: true
  }
},
  setup(__props) {

const props = __props

const refValue = ref('')
const refValueFormat = ref('')
onMounted(async () => {
  refValue.value = props.dataValue
  console.log('valueFormat=', props.valueFormat)
  console.log('pickerType=', props.pickerType)
  if (isEmptyString(props.valueFormat)) {
    if (props.pickerType === 'date') {
      refValueFormat.value = 'YYYY-MM-DD'
    } else if (props.pickerType === 'month') {
      refValueFormat.value = 'YYYY-MM'
    } else if (props.pickerType === 'month') {
      refValueFormat.value = 'YYYY'
    }
  } else {
    refValueFormat.value = props.valueFormat
  }
})


return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!

  return (_openBlock(), _createBlock(_component_el_date_picker, {
    modelValue: refValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((refValue).value = $event)),
    type: props.pickerType,
    placeholder: "Pick a day",
    size: "default",
    "value-format": refValueFormat.value
  }, null, 8, ["modelValue", "type", "value-format"]))
}
}

})